/* eslint-disable */


import {
    SET_ERRORS
} from "../mutationTypes";
import ArticleApi from "@shared/_api/article";

const state = {
    globalErrors: []
};

const actions = {
    setErrors({commit}, {errors}) {
        commit(SET_ERRORS, errors);
    },
    resetErrors({commit}, {errors}) {
        commit(SET_ERRORS, null);
    }
};

const mutations = {
    [SET_ERRORS](state, errors) {
        state.globalErrors = errors;
    }
};

export const error = {
    namespaced: true,
    state,
    actions,
    mutations
};